// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__32bD3","buttons":"Footer_buttons__3U3IZ"};